// Import the functions you need from the SDKs you need

import { getAuth } from "firebase/auth";
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage,ref } from "firebase/storage";
import { getDatabase } from "firebase/database";
// import firebase from "firebase/app";
// import "firebase/storage";

// import "firebase/storage";




// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDjDjDuXOa9lxcFgwLtocsBEo6rPOofIdo",
  authDomain: "share-to-wear.firebaseapp.com",
  databaseURL: "https://share-to-wear-default-rtdb.firebaseio.com",
  projectId: "share-to-wear",
  storageBucket: "share-to-wear.appspot.com",
  messagingSenderId: "968344669507",
  appId: "1:968344669507:web:270b4b7d7160b4af8c73f6",
};

// Initialize Firebase
 const app = initializeApp(firebaseConfig);
 export const auth = getAuth(app);
 export const db = getFirestore(app);
 export const storage = getStorage(app);
// const storage = firebase.storage();
// export const storage = firebase.storage();
  // const storageRef = firebase.storage().ref();
 export const storageRef = ref(storage);
 const database = getDatabase(app);
